import { IDateRange } from 'components/FormDateRangePickerField/FormDateRangePickerField';
import { IAuditField } from 'modules/audit/management/interfaces/IAuditField';
export enum AuditAreaAnaliticsStatus {
  SATISFACTORY = 'SATISFACTORY',
  UNSATISFACTORY = 'UNSATISFACTORY',
}

export enum AuditStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  DRAFT = 'DRAFT',
}

export interface IAuditAreaAnalitics {
  _id?: string;
  name: string;
  status: AuditAreaAnaliticsStatus;
  rate: number;
}

export interface IAudit {
  _id?: string;
  name: string;
  client: string;
  auditor?: string | undefined;
  establishment: string;
  status?: AuditStatus;
  maxScore?: number;
  template?: string;
  startDate?: Date;
  endDate?: Date;
  dateRange?: IDateRange;
  description?: string;
  areas: string[];
  generalInfo?: IAuditField[];
  createdAt?: Date;
  updatedAt?: Date;
  score?: number;
  code?: string;
}
